import { useQuery } from "@tanstack/react-query";
import { api, type MeOut } from "@/lib/api";

export function useMe() {
  return useQuery<MeOut>({
    queryKey: ["me"],
    queryFn: () => api.me(),
    retry: false,
    staleTime: 5 * 60_000,
  });
}
